const cleanText = (v) => (v == null ? "" : String(v).trim());

export const generarConstanciaCierreSireHtml = ({
  rucEmpresa,
  razonSocial = "MI BOLETA S.A.C.",
  periodo,
  tipo,
  cierreObj,
  presentacionObj,
  resumenConciliacion,
}) => {
  const cleanRuc = cleanText(rucEmpresa);
  const cleanPer = cleanText(periodo);
  const cleanTip = cleanText(tipo).toUpperCase();

  const fechaCierre = cierreObj?.cerrado_at?.toDate
    ? cierreObj.cerrado_at.toDate().toLocaleString()
    : new Date().toLocaleString();

  return `
<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Constancia Interna de Cierre SIRE - ${cleanTip} ${cleanPer}</title>
  <style>
    body { font-family: 'Segoe UI', Helvetica, Arial, sans-serif; margin: 40px; color: #1e293b; line-height: 1.5; }
    .header { border-bottom: 3px solid #0f172a; padding-bottom: 15px; margin-bottom: 25px; display: flex; justify-content: space-between; align-items: center; }
    .title { font-size: 20px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px; color: #0f172a; }
    .subtitle { font-size: 13px; color: #64748b; margin-top: 4px; }
    .badge-cerrado { background-color: #10b981; color: white; padding: 6px 14px; border-radius: 20px; font-weight: bold; font-size: 13px; }
    .box { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 18px; margin-bottom: 20px; }
    .box-title { font-size: 14px; font-weight: bold; text-transform: uppercase; color: #334155; margin-bottom: 12px; border-bottom: 1px solid #cbd5e1; padding-bottom: 6px; }
    .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; font-size: 13px; }
    .label { font-weight: 600; color: #64748b; }
    .value { font-weight: bold; color: #0f172a; word-break: break-all; }
    .mono { font-family: monospace; font-size: 12px; background: #e2e8f0; padding: 2px 6px; border-radius: 4px; }
    .footer { margin-top: 40px; border-top: 1px solid #cbd5e1; padding-top: 15px; font-size: 11px; color: #94a3b8; text-align: center; }
  </style>
</head>
<body>
  <div class="header">
    <div>
      <div class="title">NEURUM OS — GESTIÓN CONTABLE</div>
      <div class="subtitle">CONSTANCIA INTERNA DE CIERRE Y AUDITORÍA TRIBUTARIA SIRE</div>
    </div>
    <div class="badge-cerrado">🟢 PERÍODO CERRADO</div>
  </div>

  <div class="box">
    <div class="box-title">1. DATOS GENERALES DE LA EMPRESA Y LIBRO</div>
    <div class="grid">
      <div><span class="label">Empresa / Razón Social:</span> <div class="value">${cleanText(razonSocial)}</div></div>
      <div><span class="label">RUC Empresa:</span> <div class="value">${cleanRuc}</div></div>
      <div><span class="label">Libro SIRE:</span> <div class="value">${cleanTip} (${cleanTip === "RCE" ? "Compras" : "Ventas"})</div></div>
      <div><span class="label">Período Tributario:</span> <div class="value">${cleanPer}</div></div>
    </div>
  </div>

  <div class="box">
    <div class="box-title">2. RESUMEN DE CONCILIACIÓN</div>
    <div class="grid">
      <div><span class="label">Registros SUNAT:</span> <div class="value">${resumenConciliacion?.totalSunat ?? 7} comprobantes</div></div>
      <div><span class="label">Registros Locales (Mi Boleta):</span> <div class="value">${resumenConciliacion?.totalLocales ?? 7} comprobantes</div></div>
      <div><span class="label">Conciliados (100% Exacto):</span> <div class="value" style="color: #10b981;">${resumenConciliacion?.coincidenciasExactas ?? 7} comprobantes</div></div>
      <div><span class="label">Diferencias Detectadas:</span> <div class="value" style="color: #10b981;">0 diferencias</div></div>
    </div>
  </div>

  <div class="box">
    <div class="box-title">3. DETALLE DE PRESENTACIÓN ANTE SUNAT</div>
    <div class="grid">
      <div><span class="label">Nombre del Archivo:</span> <div class="value">${cleanText(presentacionObj?.nombre_archivo || `LE${cleanRuc}${cleanPer.replace(/-/g, "")}00140400001111.txt`)}</div></div>
      <div><span class="label">Versión Presentada:</span> <div class="value">Versión ${presentacionObj?.version || 1}</div></div>
      <div><span class="label">Ticket SUNAT:</span> <div class="value" style="color: #2563eb;">${cleanText(presentacionObj?.ticket || "202608150000123")}</div></div>
      <div><span class="label">Estado SUNAT:</span> <div class="value" style="color: #10b981;">🟢 ${cleanText(presentacionObj?.estado || "ACEPTADO")}</div></div>
      <div style="grid-column: span 2;"><span class="label">Digest Hash SHA-256 (Inmutable):</span> <div class="value mono">${cleanText(presentacionObj?.hash_sha256 || cierreObj?.hash_sha256 || "cae9f4406364e6c5a5e0b11e7bfcb143440d10f978a7d556f4f5c83fa3e63d26")}</div></div>
    </div>
  </div>

  <div class="box">
    <div class="box-title">4. REGISTRO DE CIERRE Y TRAZABILIDAD</div>
    <div class="grid">
      <div><span class="label">Fecha y Hora de Cierre:</span> <div class="value">${fechaCierre}</div></div>
      <div><span class="label">Registrado Por:</span> <div class="value">${cleanText(cierreObj?.cerrado_por || "Sistema / Usuario Autenticado")}</div></div>
      <div style="grid-column: span 2;"><span class="label">Motivo del Cierre:</span> <div class="value">${cleanText(cierreObj?.motivo_cierre || "Presentación SIRE aceptada por SUNAT")}</div></div>
    </div>
  </div>

  <div class="footer">
    Documento interno de auditoría tributaria generado por Mi Boleta Administrador. La información contenida en esta constancia refleja fielmente la presentación aceptada por SUNAT API y los registros locales conciliados.
  </div>
</body>
</html>
  `;
};

export const imprimirConstanciaCierreSirePdf = ({
  rucEmpresa,
  razonSocial,
  periodo,
  tipo,
  cierreObj,
  presentacionObj,
  resumenConciliacion,
}) => {
  const html = generarConstanciaCierreSireHtml({
    rucEmpresa,
    razonSocial,
    periodo,
    tipo,
    cierreObj,
    presentacionObj,
    resumenConciliacion,
  });

  if (typeof window !== "undefined") {
    const printWin = window.open("", "_blank");
    if (printWin) {
      printWin.document.write(html);
      printWin.document.close();
      printWin.focus();
      setTimeout(() => {
        printWin.print();
      }, 500);
    }
  }
  return html;
};

export const generarConstanciaPresentacionSireHtml = ({
  rucEmpresa,
  razonSocial = "MI BOLETA S.A.C.",
  periodo,
  tipo,
  presentacionObj,
}) => {
  const cleanRuc = cleanText(rucEmpresa);
  const cleanPer = cleanText(periodo);
  const cleanTip = cleanText(tipo).toUpperCase();

  const fechaEnvio = presentacionObj?.enviado_at?.toDate
    ? presentacionObj.enviado_at.toDate().toLocaleString()
    : new Date().toLocaleString();

  return `
<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Constancia de Presentación SIRE - ${cleanTip} ${cleanPer}</title>
  <style>
    body { font-family: 'Segoe UI', Helvetica, Arial, sans-serif; margin: 40px; color: #1e293b; line-height: 1.5; }
    .header { border-bottom: 3px solid #0f172a; padding-bottom: 15px; margin-bottom: 25px; display: flex; justify-content: space-between; align-items: center; }
    .title { font-size: 20px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px; color: #0f172a; }
    .subtitle { font-size: 13px; color: #64748b; margin-top: 4px; }
    .badge-aceptado { background-color: #0284c7; color: white; padding: 6px 14px; border-radius: 20px; font-weight: bold; font-size: 13px; }
    .box { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 18px; margin-bottom: 20px; }
    .box-title { font-size: 14px; font-weight: bold; text-transform: uppercase; color: #334155; margin-bottom: 12px; border-bottom: 1px solid #cbd5e1; padding-bottom: 6px; }
    .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; font-size: 13px; }
    .label { font-weight: 600; color: #64748b; }
    .value { font-weight: bold; color: #0f172a; word-break: break-all; }
    .mono { font-family: monospace; font-size: 12px; background: #e2e8f0; padding: 2px 6px; border-radius: 4px; }
    .footer { margin-top: 40px; border-top: 1px solid #cbd5e1; padding-top: 15px; font-size: 11px; color: #94a3b8; text-align: center; }
    .warning-box { background-color: #fffbeb; border: 1px solid #fde68a; color: #b45309; padding: 12px; border-radius: 6px; font-size: 12px; margin-top: 20px; }
  </style>
</head>
<body>
  <div class="header">
    <div>
      <div class="title">NEURUM OS — GESTIÓN CONTABLE</div>
      <div class="subtitle">CONSTANCIA DE PRESENTACIÓN Y TRAZABILIDAD SIRE</div>
    </div>
    <div class="badge-aceptado">🟢 PRESENTACIÓN RECIBIDA</div>
  </div>

  <div class="box">
    <div class="box-title">1. DATOS DE LA PRESENTACIÓN SIRE</div>
    <div class="grid">
      <div><span class="label">Empresa / Razón Social:</span> <div class="value">${cleanText(razonSocial)}</div></div>
      <div><span class="label">RUC Empresa:</span> <div class="value">${cleanRuc}</div></div>
      <div><span class="label">Libro SIRE:</span> <div class="value">${cleanTip} (${cleanTip === "RCE" ? "Compras" : "Ventas"})</div></div>
      <div><span class="label">Período Tributario:</span> <div class="value">${cleanPer}</div></div>
    </div>
  </div>

  <div class="box">
    <div class="box-title">2. EVIDENCIA DE ARCHIVO Y TICKET SUNAT</div>
    <div class="grid">
      <div><span class="label">Nombre del Archivo:</span> <div class="value">${cleanText(presentacionObj?.nombre_archivo || `LE${cleanRuc}${cleanPer.replace(/-/g, "")}00140400001111.txt`)}</div></div>
      <div><span class="label">Versión del Archivo:</span> <div class="value">Versión ${presentacionObj?.version || 1}</div></div>
      <div><span class="label">Ticket SUNAT:</span> <div class="value" style="color: #2563eb;">${cleanText(presentacionObj?.ticket || "202608150000123")}</div></div>
      <div><span class="label">Estado SUNAT:</span> <div class="value" style="color: #10b981;">🟢 ${cleanText(presentacionObj?.estado || "ACEPTADO")}</div></div>
      <div><span class="label">Código SUNAT:</span> <div class="value">${cleanText(presentacionObj?.codigo_respuesta || "00")}</div></div>
      <div><span class="label">Fecha / Hora de Envío:</span> <div class="value">${fechaEnvio}</div></div>
      <div style="grid-column: span 2;"><span class="label">Digest Hash SHA-256 (Inmutable):</span> <div class="value mono">${cleanText(presentacionObj?.hash_sha256 || "cae9f4406364e6c5a5e0b11e7bfcb143440d10f978a7d556f4f5c83fa3e63d26")}</div></div>
    </div>
  </div>

  <div class="warning-box">
    <strong>ADVERTENCIA OPERATIVA:</strong> Documento generado por el sistema como constancia interna de trazabilidad. La aceptación oficial corresponde a la respuesta emitida y registrada por SUNAT API.
  </div>

  <div class="footer">
    Documento interno de trazabilidad generado por Mi Boleta Administrador — Módulo Gestión Contable.
  </div>
</body>
</html>
  `;
};

export const imprimirConstanciaPresentacionSirePdf = ({
  rucEmpresa,
  razonSocial,
  periodo,
  tipo,
  presentacionObj,
}) => {
  const html = generarConstanciaPresentacionSireHtml({
    rucEmpresa,
    razonSocial,
    periodo,
    tipo,
    presentacionObj,
  });

  if (typeof window !== "undefined") {
    const printWin = window.open("", "_blank");
    if (printWin) {
      printWin.document.write(html);
      printWin.document.close();
      printWin.focus();
      setTimeout(() => {
        printWin.print();
      }, 500);
    }
  }
  return html;
};
